import clsx from 'clsx';
import { useContext } from 'react';

import { GlobalsContext, SVGImage } from '@vestico/shared';

import { getIsRTL } from '@vestico/i18n';

import style from './Banner.module.css';

export const Banner = () => {
  const { stylesConfig, useMobileLayout } = useContext(GlobalsContext);
  if (stylesConfig.stylesConfig.hideVesticoLogo) {
    return null;
  }
  const isRTL = getIsRTL();

  return (
    <div className={clsx(style.vesticoBanner, { [style.rtl]: isRTL })}>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href="https://vestico.co" target="_blank">
        <SVGImage name={useMobileLayout ? 'banner-black' : 'banner-white'} showSpinner={false} aria-label="Vestico logo" />
      </a>
    </div>
  );
};
